import CircleIcon from '@mui/icons-material/Circle';
import ActiveIcon from '@mui/icons-material/RadioButtonChecked';
import CircleOutline from '@mui/icons-material/RadioButtonUnchecked';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import times from 'lodash/times';
import React from 'react';

const Progress = ({ total, current }) => {
  return (
    <Box
      margin="auto"
      sx={{
        bgcolor: 'background.default',
        color: 'primary.main',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        p: 1,
      }}
    >
      <Stack direction="row" spacing={0.5} justifyContent="center">
        {times(total).map((i) =>
          current > i ? (
            <CircleIcon color="white" key={i} fontSize="inherit" />
          ) : current === i ? (
            <ActiveIcon color="white" key={i} fontSize="inherit" />
          ) : (
            <CircleOutline color="white" key={i} fontSize="inherit" />
          ),
        )}
      </Stack>
    </Box>
  );
};

export default Progress;
